import { Link } from "react-router-dom";
import "./ProjectCard.css";

/**
 * ProjectCard — styled as a VS Code object literal / code block.
 */
function ProjectCard({ project }) {
  return (
    <Link to={`/portfolio/projects/${project.id}`} className="project-card">
      {/* Thumbnail */}
      <div className="project-card__img-wrap">
        <img src={project.image} alt={project.title} loading="lazy" />
        <div className="project-card__overlay">
          <span className="project-card__open">Open file ↗</span>
        </div>
      </div>

      {/* Code-styled body */}
      <div className="project-card__body">
        <div className="pc-line">
          <span className="syn-const">{project.title}</span>
        </div>
        <div className="pc-line pc-desc">
          <span className="syn-orange pc-desc-text">"{project.shortDesc}"</span>
        </div>
      </div>
    </Link>
  );
}

/** "pulse-dashboard" → "pulseDashboard" */
function slugToVar(slug) {
  return slug.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
}

export default ProjectCard;
